import { BinIcon } from "../../../../components/icon/Icon.jsx";
import { closeMobileSliderPageAction } from "../../../mobileAppActions.js";
import { connect } from "react-redux";
import { useCallback } from "react";
import appHistory from "../../../../app/appHistory.js";
import classnames from "classnames";

function MobileSliderPagesCloseButton(props) {
    const {
        className,
        closeMobileSliderPage,
        closeButtonIcon,
        goBack,
        onClick,
    } = props;

    const handleClick = useCallback(() => {
        onClick && onClick();
        if (!goBack) {
            closeMobileSliderPage();
        } else {
            appHistory.goBack();
        }
    }, [goBack, closeMobileSliderPage, onClick]);

    return <div className={classnames("d-flex pointer-event", className)} onClick={handleClick}>
        <BinIcon name={closeButtonIcon || goBack ? 'IcBack' : 'IcXMark'} height="24px" width="24px"
                 style={{fill: 'var(--color-secondary-active)'}}/>
    </div>
}

const mapDispatchToProps = (dispatch) => ({
    closeMobileSliderPage: payload => dispatch(closeMobileSliderPageAction(payload)),
});

export default connect(null, mapDispatchToProps)(MobileSliderPagesCloseButton);
